var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v("I could not find what you are looking for.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }